import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';

// I18n Configuration
import createAllI18nProvider from 'I18n/init/providers/createAllI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import { LocaleProvider } from './components/locales/LocaleProvider';

// Configure the router
import { Routes } from './components/Routes';

// Apollo
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const prepareApp = async () => {
  /*
   * This should render based on the browser locale. Need to use the ALL provider instead of
   * public so locales are loaded and can be changed by our language select.
   * Doc: https://product.hubteam.com/docs/frontend/docs/i18n/new-i18n-setup.html#alli18nprovider
   * Relevant slack thread: https://hubspot.slack.com/archives/C4ABAB8CR/p1683049769060419
   */
  const I18nAllProvider = createAllI18nProvider({
    shouldSetPublicI18n: true
  });
  const langAvailable = initAppTranslations([I18nAllProvider.register(lang), registerAllData(I18nAllProvider)]);
  await langAvailable;
  const dataFetchingClient = new DataFetchingClient();
  return {
    props: {
      dataFetchingClient
    }
  };
};
export function AppComponent({
  dataFetchingClient
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: dataFetchingClient,
      children: /*#__PURE__*/_jsx(LocaleProvider, {
        children: /*#__PURE__*/_jsx(Routes, {})
      })
    })]
  });
}